export default __webpack_public_path__ + "static/media/close.eb55bdec.svg";